import { ModalCustom } from "components/ModalCustom";
import { FaExclamation } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ReprovarLoteSchema } from "../../../../../validate/reprovarLoteSchema";
import { ErroTexto, IconeCirculo, ObservacaoContainer, TextoDescricao, TituloComIcone } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (motivo: string) => void;
}

export function ModalCertezaReprovarLote({ show, handleClose, onConfirm }: IProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ReprovarLoteSchema),
  });

  useEffect(() => {
    if (!show) reset();
  }, [show]);

  const onSubmit = async (dados: { motivo: string }) => {
    await onConfirm(dados.motivo);
    reset();
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={
        <TituloComIcone>
          <IconeCirculo><FaExclamation /></IconeCirculo>
          Reprovar lote
        </TituloComIcone>
      }
      centered
      footer
      footerConfirmButton
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonText="Reprovar"
    >
      <TextoDescricao>Deseja reprovar o lote selecionado?</TextoDescricao>
      <ObservacaoContainer>
        <Form.Group>
          <Form.Label>
            Observação <span style={{ color: "#ee5353" }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Informe o motivo da reprovação"
            {...register("motivo")}
            isInvalid={!!errors.motivo}
          />
          {errors.motivo && <ErroTexto>{errors.motivo.message as string}</ErroTexto>}
        </Form.Group>
      </ObservacaoContainer>
    </ModalCustom>
  );
}
